import React from "react";

export const PhoneIcon = () => {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none">
        <path
          d="M8.5 3.5C9 3.5 11 8 11 8.5C11 9.5 9.5 10.5 9 11.5C8.5 12.5 9.5 13.5 10.5 14.5C10.89 14.89 12.5 16.5 13.5 16C14.5 15.5 15.5 14 16.5 14C17 14 21.5 16 21.5 16.5C21.5 18.5 20 20 18.5 20.5C17 21 16 21 14 20.5C12 20 10.5 19.5 8 17C5.5 14.5 5 13 4.5 11C4 9 4 8 4.5 6.5C5 5 6.5 3.5 8.5 3.5Z"
          stroke="#005585"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  );
};
